module.exports = __webpack_public_path__ + "img/akuvox-page.815bfb94.png";